import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
  FormCard, FormCardHeader, Line, StyledA, SubmitButton
} from 'styles/styled';
import {RootState} from 'store';
import styled from "styled-components";
import {Colors, Spacing} from "styles/constants";
import WarningIcon from "../../../assets/svg/warning-icon";
import AppSpinner from "../../spinner/spinner";
import { AuthActions, AuthEffects } from "../../../store/auth";
import { Routes } from "../../../routes";

const ActionText = styled.h1 `{
  font-size: 36px;
  line-height: 36px;
  font-weight: 600;
  color: ${Colors.SlateDark};
  margin-bottom: ${Spacing.Space4};
  text-align: center;
}`;

const TextContainer = styled.div `{
  text-align: center;
  width: 100%;
  color: ${Colors.SlateDark};
  margin: ${Spacing.Space4} auto;
}`;

const FailedVerifyEmail = () => {
  const dispatch = useDispatch();
  const urlExtension = useSelector((state: RootState) => state.app.urlExtension);
  const queryParams = useSelector((state: RootState) => state.app.queryParams);
  const allowToken = useSelector((state: RootState) => state.auth.allowToken);
  const rejectToken = useSelector((state: RootState) => state.auth.rejectToken);

  const navToLogin = () => {
    window.location.assign('/authenticate/login');
  }

  const handleDeauth = () => {
    allowToken && dispatch(AuthActions.setRejectToken(allowToken));
    allowToken && dispatch(AuthEffects.rejectEmail2fa(allowToken));
  };

  const handleResetPw = () => {
    window.location.assign('/authenticate' + Routes.FORGOT_PASSWORD);
  };

  const determineEmailAuthComponent = () => {
    if(allowToken) {
      return (
        <FormCard>
          <FormCardHeader>Email Authentication</FormCardHeader>
          <Line />
          <ActionText>Failed</ActionText>
          <WarningIcon size={'55'} />
          <TextContainer>
            <p>We were unable to authenticate this session. This email link can only be used one time and is only valid for 15 minutes.</p>
            <br/>
            <p>If you believe someone else may have access to your email and clicked this link before you, <StyledA as="span" onClick={handleDeauth} aria-label="deauthenticate session" >please log them out here</StyledA>.</p>
          </TextContainer>
          <SubmitButton type="button" role="button" aria-label="close" onClick={navToLogin}>Close</SubmitButton>
        </FormCard>
      );
    } else if (rejectToken) {
      return (
        <FormCard>
          <FormCardHeader>Email Authentication</FormCardHeader>
          <Line />
          <ActionText>Rejected</ActionText>
          <WarningIcon size={'55'} />
          <TextContainer>
            <p>The session for this login attempt has now been disabled.</p>
            <br/>
            <p>Because this attempt was made with your current password, <StyledA as="span" onClick={handleResetPw} aria-label="deauthenticate session" >reset your password here</StyledA>.</p>
          </TextContainer>
          <SubmitButton type="button" role="button" aria-label="close" onClick={navToLogin}>Close</SubmitButton>
        </FormCard>
      );
    } else {
      return (<AppSpinner/>);
    }
  }

  const emailAuthComponent = determineEmailAuthComponent();

  return (
    <>
      {queryParams.apply === 'emailAuth' ?
        emailAuthComponent
        :
        <FormCard>
          <FormCardHeader>Email Verification</FormCardHeader>
          <Line />
          <ActionText>Incomplete</ActionText>
          <WarningIcon size={'55'} />
          <TextContainer>
            <p>Unable to verify email.</p>
            <p>Please contact <StyledA aria-label="email support" href="mailto:support@bitpay.com">support</StyledA> if you're
              having trouble getting verified.</p>
          </TextContainer>
          <SubmitButton type="button" role="button" aria-label="close" onClick={navToLogin}>Close</SubmitButton>
        </FormCard>
      }
    </>
  );
};

export default FailedVerifyEmail;
